<template>
    <div v-if="zoomedImage" class="overlay" @click="closeZoom">
        <img :src="zoomedImage" class="zoomed" @click.stop />
        <button class="nav left" @click.stop="prevImage">‹</button>
        <button class="nav right" @click.stop="nextImage">›</button>
    </div>
</template>

<script setup>
import { onMounted, onUnmounted, ref } from "vue";

const images = ref([]);
const zoomedImage = ref(null);
const currentIndex = ref(0);

const refresh = () => {
    const imgElements = document.querySelectorAll(".img-zoomable");
    images.value = Array.from(imgElements).map(
        (img) => img.getAttribute("data-img-zoomer-src") || img.src,
    );

    imgElements.forEach((img, index) => {
        img.style.cursor = "pointer";
        img.addEventListener("click", () => openImage(index));
    });
};

const openImage = (index) => {
    currentIndex.value = index;
    zoomedImage.value = images.value[currentIndex.value];
};

const closeZoom = () => {
    zoomedImage.value = null;
};

const prevImage = () => {
    if (images.value.length > 1) {
        currentIndex.value =
            (currentIndex.value - 1 + images.value.length) %
            images.value.length;
        zoomedImage.value = images.value[currentIndex.value];
    }
};

const nextImage = () => {
    if (images.value.length > 1) {
        currentIndex.value = (currentIndex.value + 1) % images.value.length;
        zoomedImage.value = images.value[currentIndex.value];
    }
};

const handleKey = (event) => {
    if (!zoomedImage.value) return;
    if (event.key === "Escape") closeZoom();
    if (event.key === "ArrowLeft") prevImage();
    if (event.key === "ArrowRight") nextImage();
};

onMounted(() => {
    refresh();
    window.addEventListener("keydown", handleKey);
});

onUnmounted(() => {
    window.removeEventListener("keydown", handleKey);
});

defineExpose({
    refresh,
});
</script>

<style scoped>
.overlay {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.8);
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 1000;
}

.zoomed {
    max-width: 90%;
    max-height: 90%;
}

.nav {
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    background: rgba(255, 255, 255, 0.5);
    border: none;
    cursor: pointer;
    padding: 10px 15px;
    border-radius: 4px;
}

.left {
    left: 20px;
}

.right {
    right: 20px;
}
</style>
